// extracted by mini-css-extract-plugin
export default {"cls1":"mUqK1kINmHrcopYtKLO8","cls2":"bKaLEoNYCfZvJJ6s4uA6 mUqK1kINmHrcopYtKLO8"};